export default "__VITE_ASSET__DTjUse0g__"